import { render, staticRenderFns } from "./RichTextContentEditable.vue?vue&type=template&id=62849143"
import script from "./RichTextContentEditable.vue?vue&type=script&lang=js"
export * from "./RichTextContentEditable.vue?vue&type=script&lang=js"
import style0 from "./RichTextContentEditable.vue?vue&type=style&index=0&id=62849143&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports